import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { STATION_LIST_REQUEST, stationListSuccess, stationListFailure } from '../actions/stationQueryAction';
import { API_PATH }  from '../config';
import { authHeader } from '../helper/authHeader';

const STATION_LIST_API = `${API_PATH}/station`;

const stationListApi = () => {
   return axios.get(STATION_LIST_API, {
      headers: {...authHeader()},
   }).then( (response) => response.data);
}

function* stationList(action) {

   let fetch = undefined;
   try {
      fetch = yield call(stationListApi);
      if (fetch) {
         if (fetch.success) {
            yield put(stationListSuccess(fetch.result));
         } else {
            yield put(stationListFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(stationListFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(stationListFailure(`資料錯誤, ${error.message}`));
   }
}

export default function* watchStationListAction() {
   yield takeEvery(STATION_LIST_REQUEST, stationList);
}